import { render, staticRenderFns } from "./authorUpdate.vue?vue&type=template&id=5d653478&"
import script from "./authorUpdate.vue?vue&type=script&lang=js&"
export * from "./authorUpdate.vue?vue&type=script&lang=js&"
import style0 from "./authorUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports